import { http, HttpResponse } from 'msw'

export const mockUploadContract = http.put(
  '/my-business/api/agency/v1/agency-chains/upload-contract',
  async () => {
    return HttpResponse.json(null, { status: 200 })
  },
)
